import React from 'react';
import { Navigate } from 'react-router-dom';
import SuspensePage from '@/app/ui/SuspensePage';

const AdminUsers = React.lazy(() => import('@/pages/admin/AdminUsers'));
const AdminRequests = React.lazy(() => import('@/pages/admin/AdminRequests'));
const AdminAppointments = React.lazy(() => import('@/pages/admin/AdminAppointments'));
const AdminProducts = React.lazy(() => import('@/pages/admin/AdminProducts'));
const AdminCategoriesV3Page = React.lazy(() => import('@/pages/admin/AdminCategoriesV3Page'));
const AdminServices = React.lazy(() => import('@/pages/admin/AdminServices'));
const AdminMessages = React.lazy(() => import('@/pages/admin/AdminMessages'));
const AdminPurchaseRequests = React.lazy(() => import('@/pages/admin/AdminPurchaseRequests'));
const AdminStatistics = React.lazy(() => import('@/pages/admin/AdminStatistics'));
const AdminAnnonces = React.lazy(() => import('@/pages/admin/AdminAnnonces'));
const AdminChatbot = React.lazy(() => import('@/pages/admin/AdminChatbot'));
const AdminProductInterests = React.lazy(() => import('@/pages/admin/AdminProductInterests'));
const AdminLaunchNotifications = React.lazy(() => import('@/pages/admin/AdminLaunchNotifications'));
const AdminSiteMode = React.lazy(() => import('@/pages/admin/AdminSiteMode'));
const AdminProRegistrations = React.lazy(() => import('@/pages/admin/AdminProRegistrations'));
const AdminContacts = React.lazy(() => import('@/pages/admin/AdminContacts'));
const AdminImportProducts = React.lazy(() => import('@/pages/admin/AdminImportProducts'));
const AdminImportIA = React.lazy(() => import('@/pages/admin/AdminImportIA'));
const AdminSellerRequestsPage = React.lazy(() => import('@/pages/admin/AdminSellerRequestsPage'));
const AdminSellerRequestDetailPage = React.lazy(() => import('@/pages/admin/AdminSellerRequestDetailPage'));
const AdminSearchAnalytics = React.lazy(() => import('@/pages/admin/AdminSearchAnalytics'));
const AdminAnalytics = React.lazy(() => import('@/pages/admin/AdminAnalytics'));
const AdminLogs = React.lazy(() => import('@/pages/admin/AdminLogs'));
const AdminChatbotLogs = React.lazy(() => import('@/pages/admin/AdminChatbotLogs'));
const AdminImageSearchLogs = React.lazy(() => import('@/pages/admin/AdminImageSearchLogs'));
const AdminImageSearchConfig = React.lazy(() => import('@/pages/admin/AdminImageSearchConfig'));
const AdminDatabase = React.lazy(() => import('@/pages/admin/AdminDatabase'));
const AdminLanding = React.lazy(() => import('@/pages/admin/AdminLanding'));
const AdminAuditPage = React.lazy(() => import('@/pages/admin/AdminAuditPage'));
const AdminPartnersPage = React.lazy(() => import('@/pages/admin/AdminPartnersPage'));
const AdminPartnerFormPage = React.lazy(() => import('@/pages/admin/AdminPartnerFormPage'));
const AdminProductEdit = React.lazy(() => import('@/pages/admin/AdminProductEdit'));
const AdminSchemaRegistryPage = React.lazy(() => import('@/pages/admin/AdminSchemaRegistryPage'));
const AdminLLMUsage = React.lazy(() => import('@/pages/admin/AdminLLMUsage'));
const AdminSchemaRegistryFormPage = React.lazy(() => import('@/pages/admin/AdminSchemaRegistryFormPage'));
const AdminFidelityConfig = React.lazy(() => import('@/pages/admin/AdminFidelityConfig'));
const AdminPacks = React.lazy(() => import('@/pages/admin/AdminPacks'));
const AdminPackForm = React.lazy(() => import('@/pages/admin/AdminPackForm'));

const adminRoutes = [
  { index: true, element: <Navigate to="/admin/dashboard" replace /> },
  {
    path: 'dashboard',
    element: (
      <SuspensePage>
        <AdminStatistics />
      </SuspensePage>
    ),
  },
  {
    path: 'users',
    element: (
      <SuspensePage>
        <AdminUsers />
      </SuspensePage>
    ),
  },
  {
    path: 'requests',
    element: (
      <SuspensePage>
        <AdminRequests />
      </SuspensePage>
    ),
  },
  {
    path: 'appointments',
    element: (
      <SuspensePage>
        <AdminAppointments />
      </SuspensePage>
    ),
  },
  {
    path: 'products',
    element: (
      <SuspensePage>
        <AdminProducts />
      </SuspensePage>
    ),
  },
  {
    path: 'products/:productId/edit',
    element: (
      <SuspensePage>
        <AdminProductEdit />
      </SuspensePage>
    ),
  },
  {
    path: 'categories',
    element: (
      <SuspensePage>
        <AdminCategoriesV3Page />
      </SuspensePage>
    ),
  },
  {
    path: 'categories-v3',
    element: (
      <SuspensePage>
        <AdminCategoriesV3Page />
      </SuspensePage>
    ),
  },
  {
    path: 'services',
    element: (
      <SuspensePage>
        <AdminServices />
      </SuspensePage>
    ),
  },
  {
    path: 'messages',
    element: (
      <SuspensePage>
        <AdminMessages />
      </SuspensePage>
    ),
  },
  {
    path: 'purchase-requests',
    element: (
      <SuspensePage>
        <AdminPurchaseRequests />
      </SuspensePage>
    ),
  },
  {
    path: 'statistics',
    element: (
      <SuspensePage>
        <AdminStatistics />
      </SuspensePage>
    ),
  },
  {
    path: 'annonces',
    element: (
      <SuspensePage>
        <AdminAnnonces />
      </SuspensePage>
    ),
  },
  {
    path: 'chatbot',
    element: (
      <SuspensePage>
        <AdminChatbot />
      </SuspensePage>
    ),
  },
  {
    path: 'chatbot-logs',
    element: (
      <SuspensePage>
        <AdminChatbotLogs />
      </SuspensePage>
    ),
  },
  {
    path: 'image-search-logs',
    element: (
      <SuspensePage>
        <AdminImageSearchLogs />
      </SuspensePage>
    ),
  },
  {
    path: 'image-search-config',
    element: (
      <SuspensePage>
        <AdminImageSearchConfig />
      </SuspensePage>
    ),
  },
  {
    path: 'product-interests',
    element: (
      <SuspensePage>
        <AdminProductInterests />
      </SuspensePage>
    ),
  },
  {
    path: 'site-mode',
    element: (
      <SuspensePage>
        <AdminSiteMode />
      </SuspensePage>
    ),
  },
  {
    path: 'pro-registrations',
    element: (
      <SuspensePage>
        <AdminProRegistrations />
      </SuspensePage>
    ),
  },
  {
    path: 'contacts',
    element: (
      <SuspensePage>
        <AdminContacts />
      </SuspensePage>
    ),
  },
  {
    path: 'import-products',
    element: (
      <SuspensePage>
        <AdminImportProducts />
      </SuspensePage>
    ),
  },
  {
    path: 'import-ia',
    element: (
      <SuspensePage>
        <AdminImportIA />
      </SuspensePage>
    ),
  },
  {
    path: 'seller-requests',
    element: (
      <SuspensePage>
        <AdminSellerRequestsPage />
      </SuspensePage>
    ),
  },
  {
    path: 'seller-requests/:requestId',
    element: (
      <SuspensePage>
        <AdminSellerRequestDetailPage />
      </SuspensePage>
    ),
  },
  {
    path: 'search-analytics',
    element: (
      <SuspensePage>
        <AdminSearchAnalytics />
      </SuspensePage>
    ),
  },
  {
    path: 'analytics',
    element: (
      <SuspensePage>
        <AdminAnalytics />
      </SuspensePage>
    ),
  },
  {
    path: 'logs',
    element: (
      <SuspensePage>
        <AdminLogs />
      </SuspensePage>
    ),
  },
  {
    path: 'database',
    element: (
      <SuspensePage>
        <AdminDatabase />
      </SuspensePage>
    ),
  },
  {
    path: 'launch-notifications',
    element: (
      <SuspensePage>
        <AdminLaunchNotifications />
      </SuspensePage>
    ),
  },
  {
    path: 'landing',
    element: (
      <SuspensePage>
        <AdminLanding />
      </SuspensePage>
    ),
  },
  {
    path: 'audit',
    element: (
      <SuspensePage>
        <AdminAuditPage />
      </SuspensePage>
    ),
  },
  {
    path: 'partners',
    element: (
      <SuspensePage>
        <AdminPartnersPage />
      </SuspensePage>
    ),
  },
  {
    path: 'partners/new',
    element: (
      <SuspensePage>
        <AdminPartnerFormPage />
      </SuspensePage>
    ),
  },
  {
    path: 'partners/:id/edit',
    element: (
      <SuspensePage>
        <AdminPartnerFormPage />
      </SuspensePage>
    ),
  },
  {
    path: 'llm-tokens',
    element: (
      <SuspensePage>
        <AdminLLMUsage />
      </SuspensePage>
    ),
  },
  {
    path: 'schema-registry',
    element: (
      <SuspensePage>
        <AdminSchemaRegistryPage />
      </SuspensePage>
    ),
  },
  {
    path: 'schema-registry/new',
    element: (
      <SuspensePage>
        <AdminSchemaRegistryFormPage />
      </SuspensePage>
    ),
  },
  {
    path: 'schema-registry/:schemaId',
    element: (
      <SuspensePage>
        <AdminSchemaRegistryFormPage />
      </SuspensePage>
    ),
  },
  {
    path: 'fidelity',
    element: (
      <SuspensePage>
        <AdminFidelityConfig />
      </SuspensePage>
    ),
  },
  {
    path: 'packs',
    element: (
      <SuspensePage>
        <AdminPacks />
      </SuspensePage>
    ),
  },
  {
    path: 'packs/new',
    element: (
      <SuspensePage>
        <AdminPackForm />
      </SuspensePage>
    ),
  },
  {
    path: 'packs/:id/edit',
    element: (
      <SuspensePage>
        <AdminPackForm />
      </SuspensePage>
    ),
  },
];

export default adminRoutes;
